import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=c95f38ec&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=ts&"
export * from "./DesktopMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95f38ec",
  null
  
)

export default component.exports